import React from "react";
import ProfileHeader from "../GroupProfileHeader/GroupProfileHeader";
import GroupHeader from "../GroupHeader/GroupHeader";

export default function GroupHeaderSection({
  totalUsers,
  channelActiveChat,
  setShowProfileView,
  setActiveSection,
}) {
  return (
    <>
      <header className="w-full min-h-[45px] py-2.5 bg-white dark:bg-slate-900 flex items-center justify-between border-b border-[#EBEBEB] dark:border-slate-700 text-black dark:text-white p-4 text-center">
        <GroupHeader
          totalUsers={totalUsers}
          setShowProfileView={setShowProfileView}
          channelActiveChat={channelActiveChat}
          setActiveSection={setActiveSection}
        />
      </header>
    </>
  );
}
